export default [
  {
    path: 'required-docs',
    name: 'required-docs',
    component: () => import('@/views/pages/front/RequiredDocs.vue'),
    meta: {
      pageTitle: 'Required documents',
      breadcrumb: [
        {
          text: 'Required documents',
          active: true,
        },
      ],
    },
  },
]
